import { render, staticRenderFns } from "./BoardMessage.vue?vue&type=template&id=18091e9c&scoped=true"
import script from "./BoardMessage.vue?vue&type=script&lang=ts"
export * from "./BoardMessage.vue?vue&type=script&lang=ts"
import style0 from "./BoardMessage.vue?vue&type=style&index=0&id=18091e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18091e9c",
  null
  
)

export default component.exports